import { Checkbox, FormControlLabel, FormGroup, Slide } from "@mui/material";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { closeCustomDrawer } from "../../redux/slices/modalSlice";
import { approveDiscountNotification, fetchNotificationCount, fetchReadSingleNotification } from "../../redux/slices/notifications";
import productImg from '../../assets/images/placeholderproduct.svg';

function isWithin15Minutes(timestamp) {
    // Get the current time
    let now = moment();

    // Convert the given timestamp to a moment object
    let time = moment(+timestamp);

    // Calculate the difference in minutes
    let difference = moment.duration(now.diff(time)).asMinutes();
    // Check if the difference is within -15 to 15 minutes
    return Math.abs(difference)?.toFixed()
}

const returnOrderTimeWiseClass = (timestamp) => {
    const orderPreparingTime = 15 - isWithin15Minutes(timestamp)
    return orderPreparingTime <= 15 && orderPreparingTime > 10 ? 'success' : orderPreparingTime <= 10 && orderPreparingTime > 5 ? 'warning' : orderPreparingTime <= 5 && (orderPreparingTime > 0 || orderPreparingTime <= 0) ? 'alert' : ''
}

export default function OrderNotificationCard({ notification, notificationShow = 'stack', hideNotificationHandler = () => { } }) {
    let orderTimeInterval = useRef()
    const [remainingTime, setRemainingTime] = useState('')
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [isApproved, setIsApproved] = useState(!!notification?.notificationData?.approved)
    const metrcDaysRemaining = Number(notification?.order?.[0]?.daysRemaining)
    const metrcUrgency = metrcDaysRemaining <= 7 ? 'urgent' : metrcDaysRemaining <= 30 ? 'warning' : 'safe'
    useEffect(() => {
        setIsApproved(!!notification?.notificationData?.approved)
    }, [notification?.notificationData?.approved])

    useEffect(() => {
        const intervalId = setInterval(() => {
            // Calculate the difference in minutes
            const difference = isWithin15Minutes(notification?.createdDate);
            setRemainingTime(15 - difference);
            // Check if the difference is greater than 15 minutes
            if (difference > 15) {
                clearInterval(intervalId);

            }
        }, 1000); // Check every second (1000 ms)

        // Clean up the interval on component unmount
        return () => clearInterval(intervalId);
    }, [notification?.createdDate]);
    console.log("notification", notification);

    const handleApprove = (notificationData) => {

        if (isApproved) return;
        // if ( notificationData?.notificationType !== 'Discount POS') return;

        setIsApproved(true);
        const payload = {
            "notificationId": notificationData?.notificationId,
            "storeId": notificationData?.storeId,
        }

        dispatch(approveDiscountNotification(payload)).unwrap().then(() => {
            dispatch(fetchNotificationCount());
        }).catch(() => {
            setIsApproved(false);
        });

        dispatch(fetchReadSingleNotification({
            "notificationId": notification?.notificationId,
            "storeId": notification?.storeId,
        })).unwrap().then(() => {
            dispatch(fetchNotificationCount({ storeId: notification?.storeId }))
        });
    }

    return (
        notificationShow === 'stack' ?
            <Slide direction="left" in={true} mountOnEnter unmountOnExit >
                <div onClick={() => {
                    navigate(`/orders/details/${notification?.orderId}`)
                }} className={`cus-notification-card cur-pointer ${returnOrderTimeWiseClass(notification?.createdDate)}`}>
                    <p className="w-100 d-flex align-items-center justify-content-between p-3 fs-x-small bar-bg font-weight-600 text-grey-500">
                        <span>Order ID <b className="text-grey-600 fs-small">{notification?.orderId}</b></span>
                        <span>{15 - isWithin15Minutes(notification?.createdDate) > 0 ? `${15 - isWithin15Minutes(notification?.createdDate)} min` : '0 min'} </span>
                    </p>

                    <ul className="w-100">
                        {
                            notification?.order?.map((orderItem => {
                                return <li key={orderItem} className="w-100 d-flex align-items-center justify-content-between gap-2 px-3 py-2">
                                    <div className="d-flex align-items-center justify-content-between gap-2">
                                        <div className="d-flex align-items-center">
                                            <img width={44} height={44} src={orderItem?.productImage || productImg} className="object-fit-contain" />
                                        </div>
                                        <p className="text-grey-600 fs-small font-weight-500 m-0 white-space-normal word-break-all">{orderItem?.Name}</p>
                                    </div>
                                    <span className="text-grey-500 fs-small font-weight-400">x{orderItem?.Quantity}</span>
                                </li>
                            }))
                        }

                    </ul>
                    <p className="w-100 d-flex align-items-center justify-content-between px-3 py-1 fs-small font-weight-500">
                        <FormGroup>
                            <FormControlLabel control={<Checkbox disabled defaultChecked />} label="Ready for Pickup" />
                        </FormGroup>
                        {
                            notificationShow === 'stack' && <badge onClick={(e) => {
                                e.stopPropagation()
                                hideNotificationHandler(notification?.orderId)
                            }} className="text-grey-500 bg-grey-200 border-radius-4 cur-pointer">Hide</badge>
                        }
                    </p>
                </div>
            </Slide> :
            notification?.notificationType === 'Discount POS' ?
                <div
                    className={`cus-notification-card card-discount cur-pointer ${returnOrderTimeWiseClass(notification?.createdDate)}`}>
                    <p className="w-100 d-flex align-items-center justify-content-between p-3 fs-x-small bar-bg bar-bg-discount font-weight-600">
                        <span>Discount</span>
                    </p>
                    <div className="p-3">
                        <p className="text-grey-600 fs-small font-weight-500 m-0 white-space-normal word-break">Email: {notification?.notificationData?.email}</p>
                        <p className="text-grey-600 fs-small font-weight-500 m-0 white-space-normal word-break">Name: {notification?.notificationData?.userName}</p>
                        <p className="text-grey-600 fs-small font-weight-500 m-0 white-space-normal word-break">Discount Type: {notification?.notificationData?.discountType}</p>
                        <p className="text-grey-600 fs-small font-weight-500 m-0 white-space-normal word-break">Discount Amount: {notification?.notificationData?.discountAmount}</p>

                    </div>
                    <p className="w-100 d-flex align-items-center justify-content-between px-3 py-1 fs-small font-weight-500 card-footer">
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={isApproved}
                                        disabled={isApproved}
                                        onChange={(e) => {
                                            e.stopPropagation();
                                            handleApprove(notification);
                                        }}
                                    />
                                }
                                label="Approve"
                            />
                             </FormGroup>
                    </p>
                </div>
                : notification?.notificationType === 'return' ?
                    <div
                        className={`cus-notification-card card-return cur-pointer ${returnOrderTimeWiseClass(notification?.createdDate)}`}>
                        <p className="w-100 d-flex align-items-center justify-content-between p-3 fs-x-small bar-bg bar-bg-return font-weight-600">
                            <span>Return</span>
                        </p>
                        <div className="p-3">
                            <p className="text-grey-600 fs-small font-weight-500 m-0 white-space-normal word-break">Email: {notification?.email}</p>
                            <p className="text-grey-600 fs-small font-weight-500 m-0 white-space-normal word-break">Name: {notification?.notificationData?.userName}</p>
                            <p className="text-grey-600 fs-small font-weight-500 m-0 white-space-normal word-break">OrderId: {notification?.notificationData?.orderId}</p>
                            <p className="text-grey-600 fs-small font-weight-500 m-0 white-space-normal word-break">Comment: {notification?.notificationData?.returnComments}</p>

                        </div>
                        <p className="w-100 d-flex align-items-center justify-content-between px-3 py-1 fs-small font-weight-500 card-footer">
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={isApproved}
                                            disabled={isApproved}
                                            onChange={(e) => {
                                                e.stopPropagation();
                                                handleApprove(notification);
                                            }}
                                        />
                                    }
                                    label="Approve"
                                />
                            </FormGroup>

                        </p>
                    </div> : notification?.notificationType === 'productDiscount' ?
                        <div
                            className={`cus-notification-card card-discount cur-pointer ${returnOrderTimeWiseClass(notification?.createdDate)}`}>
                            <p className="w-100 d-flex align-items-center justify-content-between p-3 fs-x-small bar-bg bar-bg-discount font-weight-600">
                                <span>Product Discount</span>
                            </p>
                            <div className="p-3">
                                <p className="text-grey-600 fs-small font-weight-500 m-0 white-space-normal word-break">Email: {notification?.email}</p>
                                <p className="text-grey-600 fs-small font-weight-500 m-0 white-space-normal word-break">Name: {notification?.notificationData?.userName}</p>
                                <p className="text-grey-600 fs-small font-weight-500 m-0 white-space-normal word-break">Product Id: {notification?.notificationData?.productId}</p>
                                <p className="text-grey-600 fs-small font-weight-500 m-0 white-space-normal word-break">Discount Value: {notification?.notificationData?.discountValue}</p>
                            </div>
                            <p className="w-100 d-flex align-items-center justify-content-between px-3 py-1 fs-small font-weight-500 card-footer">
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={isApproved}
                                                disabled={isApproved}
                                                onChange={(e) => {
                                                    e.stopPropagation();
                                                    handleApprove(notification);
                                                }}
                                            />
                                        }
                                        label="Approve"
                                    />
                                </FormGroup>
                            </p>
                        </div> : notification?.notificationType === 'metrcKeyRenewalBuffer' ?
                            <div
                                className={`cus-notification-card card-metrc-${metrcUrgency} cur-pointer ${returnOrderTimeWiseClass(notification?.createdDate)}`}>
                                <p className={`w-100 d-flex align-items-center justify-content-between p-3 fs-x-small bar-bg bar-bg-metrc-${metrcUrgency} font-weight-600`}>
                                    <span>Metrc Key Renewal Buffer</span>
                                    {/* <span>{15 - isWithin15Minutes(notification?.createdDate) > 0 ? `${15 - isWithin15Minutes(notification?.createdDate)} min` : '0 min'} </span> */}
                                </p>
                                <div className="p-3">
                                    <p className="text-grey-600 fs-small font-weight-500 m-0 white-space-normal word-break">Store Name: {notification?.order?.[0]?.storeName}</p>
                                    <p className="text-grey-600 fs-small font-weight-500 m-0 white-space-normal word-break">Expiration Date: {notification?.order?.[0]?.expirationDate}</p>
                                    <p className="text-grey-600 fs-small font-weight-500 m-0 white-space-normal word-break days-remaining">Days Remaining: <span>{notification?.order?.[0]?.daysRemaining}</span></p>
                                </div>
                            </div> :
                            <div onClick={() => {
                                if (!notification?.readStatus) {
                                    dispatch(fetchReadSingleNotification({
                                        "notificationId": notification?.notificationId,
                                        "storeId": notification?.storeId,
                                    })).unwrap().then(() => {
                                        dispatch(fetchNotificationCount({ notificationType: 'order', storeId: notification?.storeId }))
                                    });
                                }
                                navigate(`/ecom-orders/details/${notification?.orderId}`)
                                dispatch(closeCustomDrawer({}))

                            }} className={`cus-notification-card card-order cur-pointer ${returnOrderTimeWiseClass(notification?.createdDate)}`}>
                                <p className="w-100 d-flex align-items-center justify-content-between p-3 fs-x-small bar-bg bar-bg-order font-weight-600">
                                    {
                                        notification?.notificationType === 'Discount POS' ?
                                            <span>Discount POS</span> :
                                            <span>Order ID <b className="text-grey-600 fs-small">{notification?.orderId}</b></span>
                                    }
                                </p>
                                <ul className="w-100">
                                    {
                                        notification?.order?.map((orderItem => {
                                            return <li key={orderItem} className="w-100 d-flex align-items-center justify-content-between gap-2 px-3 py-2">
                                                <div className="d-flex align-items-center justify-content-between gap-2">
                                                    <div className="d-flex align-items-center">
                                                        <img width={44} height={44} src={orderItem?.productImage || productImg} className="object-fit-contain" />
                                                    </div>
                                                    <p className="text-grey-600 fs-small font-weight-500 m-0 white-space-normal word-break">{orderItem?.Name}</p>
                                                </div>
                                                <span className="text-grey-500 fs-small font-weight-400">x{orderItem?.Quantity}</span>
                                            </li>
                                        }))
                                    }

                                </ul>
                                <p className="w-100 d-flex align-items-center justify-content-between px-3 py-1 fs-small font-weight-500 card-footer">
                                    <FormGroup>
                                        <FormControlLabel control={<Checkbox disabled defaultChecked />} label={getFulfillmentStatusLabel(notification?.notificationData?.orderStatus)} />
                                    </FormGroup>
                                    {
                                        notificationShow === 'stack' && <badge onClick={(e) => {
                                            e.stopPropagation()
                                            hideNotificationHandler(notification?.orderId)
                                        }} className="text-grey-500 bg-grey-200 border-radius-4 cur-pointer">Hide</badge>
                                    }
                                </p>
                            </div>

    )
}